import { gql } from '../../__generated__/gql'

export const DOWNLOAD_STORE_FILE_MUTATION = gql(`
  mutation downloadStoreFile($id: Int!, $key: String) {
    downloadStoreFile(input: {  id: $id, key: $key  }) {
      url
    }
  }
`)
